import React from 'react';
import { useI18n } from '../context/I18nContext';

export default function LanguageToggle({ className = '' }) {
  const { locale, toggle } = useI18n();
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="lang-toggle"
      className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-xs font-display font-semibold text-white/80 hover:border-aura-cyan/50 hover:text-white transition ${className}`}
      aria-label="Toggle language"
    >
      <span className={locale === 'es' ? 'text-aura-cyan' : 'opacity-60'}>ES</span>
      <span className="opacity-30">/</span>
      <span className={locale === 'en' ? 'text-aura-cyan' : 'opacity-60'}>EN</span>
    </button>
  );
}
